import React from 'react'
import { NegotiationType, NegotiationDetailWithMeta } from 'api'
import { ActionsButtonProps } from 'view/components/datagrid/renderers'
import { LiveActionsButton } from './LiveActionsButton'
import { LiveLockRenderer } from './LiveLockRenderer'
import { EmptyLockRenderer } from 'view/shared/datagrid'
import { isTerminalStatus, isSummaryNegotiationType } from 'view/routes/requests/shared/utils'
import { GridId } from 'store/grid'
import { isAonOrOcoCollection } from 'model'
import { iconSet } from 'view/components/icons'
import { Container as IconContainer } from 'view/components/datagrid/renderers/GroupCellRenderer'
import { isCollectionColumn } from 'view/components/datagrid'
import { getInitiatedTogglesOptions } from '../initiated/InitiatedGroupByToggles'

export const LiveActionsCell: React.FunctionComponent<ActionsButtonProps<NegotiationDetailWithMeta>> = props => {
  const { gridApi, context, items, isGroupRow, isCounterpartyNegotiation, dataTestId } = props
  const negotiationDetail = items[0]

  if (!negotiationDetail?.negotiation) {
    return null
  }

  const getLockRenderer = (): JSX.Element | null => {
    // if we are viewing a "done" screen or an "initiated" screen display neither the lock or its placeholder
    if (isTerminalStatus(negotiationDetail.negotiation.status) || negotiationDetail.ownOrder) {
      return null
    }

    // if we are viewing a non-AON group row or an AON row show a spacer
    if (
      negotiationDetail.negotiation.negotiationType === NegotiationType.CONTINGENT_ITEM ||
      (isGroupRow && negotiationDetail.negotiation.negotiationType !== NegotiationType.CONTINGENT_SUMMARY)
    ) {
      return <EmptyLockRenderer data-test-id="LiveActionsCell-EmptyLockRenderer" />
    }

    return <LiveLockRenderer negotiationDetail={negotiationDetail} />
  }

  const getCollectionRenderer = (): JSX.Element | null => {
    const rowGroupColumns = gridApi?.getRowGroupColumns() ?? []

    if (
      (context?.gridId === GridId.IncomingGrid || context?.gridId === GridId.InitiatedGrid) &&
      !isGroupRow &&
      !rowGroupColumns.some(isCollectionColumn) &&
      isAonOrOcoCollection(negotiationDetail.collection?.type)
    ) {
      return (
        <IconContainer data-test-id="LiveActionsCell-Collection-Icon" nestingLevel={0} isGroup={false}>
          {iconSet.collectionIcon}
        </IconContainer>
      )
    }

    return null
  }

  // Treat summary as not a group row
  return (
    <>
      <LiveActionsButton
        negotiationDetails={items}
        groupByOption={context?.gridId === GridId.InitiatedGrid && gridApi ? getInitiatedTogglesOptions(gridApi) : null}
        gridApi={gridApi}
        isGroupRow={isGroupRow && !isSummaryNegotiationType(items[0].negotiation.negotiationType)}
        isCounterpartyNegotiation={isCounterpartyNegotiation}
        dataTestId={dataTestId}
      />
      {getLockRenderer()}
      {getCollectionRenderer()}
    </>
  )
}
